
import { Input } from "element-ui"
import { getCartCheckedCount, showGlobalMessage, openNoAddressPop } from "../../utils/utils"
import { handleModifyCartV2 } from "@/utils/cartResponse"
export default {
  name: "CmsInputNumber",
  components: {
    [Input.name]: Input
  },
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    sku: {
      type: [Number, String],
      default: ""
    },
    skuType: {
      type: [Number, String],
      default: ""
    },
    maxlength: {
      type: Number,
      default: 2
    },
    min: {
      type: Number,
      default: 1
    },
    max: {
      type: Number,
      default: 99
    },
    styleConfig: {
      type: Object,
      default: () => {}
    },
    ware: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      curValue: this.value,
      focused: false,
      commonReqParams: {},
      oldValue: ""
    }
  },
  computed: {
    increaseDisabled() {
      return Number(this.curValue) >= this.max
    },
    reduceDisabled() {
      return Number(this.curValue) <= this.min
    }
  },
  watch: {
    value() {
      this.curValue = this.value
    }
  },
  created() {
    if (!process.client) {
      return
    }
    const { commonReqParams } = this.$commonParams
    this.commonReqParams = commonReqParams
  },
  methods: {
    handleInput(value) {
      this.curValue = value.replace(/[^\d]/g, "")
      if (this.curValue == 0) {
        this.curValue = ""
      }
    },
    handleBlur() {
      this.focused = false
    },
    handleFocus() {
      this.focused = true
    },
    reduce() {
      this.handleChange("reduce", this.curValue)
    },
    increase() {
      if (this.increaseDisabled) return
      this.handleChange("increase", this.curValue)
    },
    async handleChange(type = "change", value) {
      // console.log("value===>", Number(value), this.curValue)
      if (value === "") {
        this.curValue = value = this.min
      }
      if (value > this.max) {
        this.curValue = value = this.max
        const headerEl = document.getElementById("top-box")
        const headerHeight = (headerEl && headerEl.clientHeight) || 0
        const gap = 16
        showGlobalMessage({
          message: this.$t("cart.maximumStockTips"),
          gap: headerHeight + gap,
          iconClass: "messageWarning"
        })
      }
      if (this.focused) {
        this.$refs.input && this.$refs.input.blur()
      }
      let count = null
      if (type == "reduce") {
        count = Number(this.curValue) - 1
      } else if (type == "increase") {
        count = Number(this.curValue) + 1
      } else {
        count = Number(this.curValue)
      }
      const beforeCount = type == "reduce" || type == "increase" ? this.curValue : this.value
      const { venderId, storeId } = this.ware
      const [error, data, wareList] = await handleModifyCartV2({
        venderId,
        storeId: storeId || this.commonReqParams.storeId,
        wares: [{ sku: this.sku, beforeCount, count, checked: 1 }],
        sort: 1
      })
      if (data) {
        if (type == "reduce") {
          this.curValue = Number(this.curValue) - 1
        } else if (type == "increase") {
          this.curValue = Number(this.curValue) + 1
        }
        this.$emit("handleNumChange", this.curValue, wareList)

        console.log("this.ware", this.ware, beforeCount, count)
      } else {
        console.log(error)
        console.log("加购失败")
        this.curValue = this.value
        if (error && error.code == "44999") {
          openNoAddressPop()
        }
      }
    }
  }
}
